import React, { lazy, Suspense, useEffect, type ReactElement } from 'react'

import { Loader } from '../components/Loader'
import { updatePlatformHeader } from '../services/api/auth'
import { getAccessToken } from '../services/authentication'
import { setPlatformForLogs } from '../services/datadog'
import { environmentVariables } from '../utils/environmentVariables'
import { redirectToUrl } from '../utils/location'

const LazyChangePasswordPage = lazy(() =>
  import('../pages/ChangePassword').then((module) => ({ default: module.ChangePasswordPage })),
)

export const ChangePasswordAndroidRoute = (): ReactElement => {
  const platform = 'android'

  updatePlatformHeader(platform)
  setPlatformForLogs(platform)

  useEffect(() => {
    if (!getAccessToken()) {
      redirectToUrl(`${environmentVariables('AUTH_API_URL')}/signin`)
    }
  }, [])

  if (!getAccessToken()) {
    return <Loader />
  }

  return (
    <Suspense fallback={<Loader />}>
      <LazyChangePasswordPage showBackButton={false} />
    </Suspense>
  )
}
